<template>
  <div
    v-on-clickaway="handleClickAway"
    class="date-reference-select-filter date-reference-select-filter-selector"
  >
    <span class="date-reference-select-filter--icon">
      <img
        :src="require('@/assets/img/icons/icon-calendar.svg')"
        alt="search"
      >
    </span>
    <div
      class="multiselect"
      @click="showDateSelector"
    >
      <div class="multiselect__tags">
        <span class="multiselect__single">{{dateSelected.name}}</span>
      </div>
    </div>
    <ul v-if="showDateSelectorFlag">
      <li>
        <span class="label-selector">{{$t('transactions_filter_by_date')}}</span>
        <date-select
          size="small"
          :icon="false"
          :initialize="false"
          :initialDate="dateSelected"
          @selectDate="selectDate"
          @emitInitialValue="setDate"
        ></date-select>
      </li>
      <li>
        <span class="label-selector">{{$t('transactions_export_reference_date')}}</span>
        <div class="multiselect-filter">
          <multi-select
            :value="referenceDate"
            :options="referenceDateOptionsFiltered"
            :customLabel="option => $t(option.name)"
            :placeholder="$t('transactions_export_creation_date')"
            :allow-empty="false"
            :track-by="'key'"
            :selectLabel="''"
            :deselectLabel="''"
            :clear-on-select="true"
            :close-on-select="true"
            :searchable="false"
            :disabled="disableReferenceSelect"
            @select="selectReferenceDate($event)"
          >
            <div
              class="caret"
              slot="caret"
              slot-scope="{ toggle }"
              @mousedown.prevent.stop="toggle"
            >
              <i
                class="Ctrl Ctrl--16"
                aria-hidden="true"
              >
                <svg
                  focusable="false"
                  aria-hidden="true"
                  aria-label="Edit"
                >
                  <use xlink:href="#dropdown-icon"></use>
                </svg>
              </i>
            </div>
          </multi-select>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'
import transactionPeriodsMixin from '@/modules/transactions/_mixins/_transactionPeriods'
import MultiSelect from 'vue-multiselect'
import DateSelect from './DateSelect.vue'

export default {
  name: 'DateSelectReference',
  components: {
    MultiSelect,
    DateSelect
  },
  mixins: [transactionPeriodsMixin, clickaway],
  computed: {
    mask () {
      return '##/##/####'
    },
    periodsFiltered () {
      return this.periods
    },
    referenceDateOptionsFiltered () {
      return this.referenceDateOptions.filter(item => {
        if (this.$route.name.includes('pending')) {
          return (item.type === this.type || !item.type) && !item.excludeOnPendingReview
        } else {
          return item.type === this.type || !item.type
        }
      })
    },
    disableReferenceSelect () {
      return this.dateSelected?.id === 'historic' || false
    }
  },
  props: {
    type: {
      type: String,
      default: 'transaction'
    },
    usersGrouping: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      filters: {},
      dateSelected: {},
      selectedRange: null,
      rangeIsSelected: false,
      inputAfter: null,
      inputBefore: null,
      resetDatePicker: false,
      referenceDateOptions: [{
        name: 'transactions_export_creation_date',
        key: 'createdAt'
      }, {
        name: 'transactions_export_approve_date',
        key: 'reviewedAt',
        excludeOnPendingReview: true
      }, {
        name: 'transactions_export_expense_date',
        key: 'date',
        type: 'expense'
      }, {
        name: 'transactions_export_confirmation_date',
        key: 'confirmationDate',
        type: 'transaction'
      }],
      showDateSelectorFlag: false,
      referenceDate: {
        name: 'transactions_export_creation_date',
        key: 'createdAt'
      }
    }
  },
  methods: {
    handleClickAway () {
      this.showDateSelectorFlag = false
    },
    showDateSelector () {
      this.showDateSelectorFlag = !this.showDateSelectorFlag
    },
    selectReferenceDate (event) {
      this.referenceDate = event
      this.selectDate(this.dateSelected)
    },
    async selectDate (filters) {
      this.dateSelected = filters
      let filter = {}
      this.clearDates()
      filter[`${this.referenceDate.key}[after]`] = filters.filter['date[after]']
      filter[`${this.referenceDate.key}[before]`] = filters.filter['date[before]']

      await this.$store.dispatch('TransactionsStore/setTransactionsFilters', { filters: { ...this.filters, ...filter }, force: true, users: this.usersGrouping })
      await this.$store.dispatch('TransactionsStore/fetchTransactionDashboard')
    },
    clearDates () {
      let filters = this.$store.getters['TransactionsStore/filters']
      delete filters['date[after]']
      delete filters['date[before]']
      delete filters['createdAt[after]']
      delete filters['createdAt[before]']
      delete filters['reviewedAt[after]']
      delete filters['reviewedAt[before]']
      delete filters['date[after]']
      delete filters['date[before]']
      delete filters['confirmationDate[after]']
      delete filters['confirmationDate[before]']
      this.filters = filters
    },
    setDate (filters) {
      this.dateSelected = filters
    }
  },
  created () {
    if (this.periodDefault === 'noDefault') return
    this.dateSelected = this.periodsFiltered.find(el => {
      if (this.$route.query && this.$route.query.selectedPeriod) {
        return el.id === (this.$route.query && this.$route.query.selectedPeriod)
      } else if (this.periodDefault) {
        return this.periodDefault === el.id
      } else {
        return el.default
      }
    })
  }
}
</script>

<style lang="scss">
.date-reference-select-filter {
  position: relative;
  background-color: var(--grey-action-3-active);
  border-radius: 4px;
  .multiselect {
    color: var(--text-body);
    &__tags {
      background-color: var(--grey-action-3-active);
    }
  }
  &.date-reference-select-filter-selector {
    min-width: 229px;
    width: 229px;
    height: 40px;
    min-height: 40px;
    margin-right: 16px;
  }
  &--icon {
    width: 16px;
    height: 16px;
    line-height: 0;
    top: 12px;
    left: 14px;
    position: absolute;
  }
  &--container {
    position: absolute;
    margin: 5px 0 0 0;
    padding: 16px;
    padding-bottom: 0;
    z-index: 1;
    background: var(--white);
    border: 1px solid #eeeff0;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    @media screen and (max-width: 576px) {
      right: 0;
    }
  }
  &--inputs {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &--date-picker {
    .vc-container {
      border: none;
      width: 100%;
      .vc-weeks {
        padding: 0;
      }
      .vc-arrows-container {
        padding: 8px 4px;
      }
    }
  }
  &--input {
    width: 100%;
    height: 40px;
    border: none;
    appearance: none;
    --webkit-appearance: none;
    background-color: var(--grey-action-3-active);
    border-radius: 4px;
    font-weight: 300;
    font-size: 15px;
    padding: 10px;
    margin: 0 15px 0 5px;
    &.before {
      margin: 0 5px 0 15px;
    }
  }
  .multiselect {
    box-sizing: border-box;
    padding-left: 40px;
    .caret {
      right: 2px;
      height: 40px;
    }
    &__content-wrapper {
      left: 0;
    }
    &__placeholder {
      color: var(--gray);
      line-height: 40px;
      height: 40px;
      padding: 0;
      margin: 0;
      padding-left: 0;
    }
    &__tags,
    &__single {
      max-width: 100%;
      line-height: 40px;
      height: 40px;
      min-height: 40px;
      padding-left: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  ul:not(.multiselect__content) {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    width: 436px;
    background-color: var(--white);
    border: 1px solid var(--fill-divider);
    border-radius: 4px;
    padding: 10px 12px;
    margin: 0;
    margin-left: -16px;
    list-style: none;
    z-index: 99;
    box-shadow: 0 4px 14px rgb(0 0 0 / 15%);
    .label-selector {
      display: block;
      font-weight: 500;
      font-size: 9px;
      line-height: 12px;
      letter-spacing: 1px;
      text-transform: uppercase;
      color: var(--text-subheading);
      margin-bottom: 4px;
    }
    li {
      line-height: 16px;
      .multiselect-filter {
        border-radius: 4px;
        background-color: var(--grey-action-3-active);
      }
      .multiselect {
        padding-left: 12px;
        height: 32px;
        min-height: 32px;
        max-height: 32px;
        width: 200px;
        .caret {
          height: 32px;
          min-height: 32px;
          max-height: 32px;
        }
        &__placeholder {
          line-height: 32px;
          height: 32px;
        }
        &__tags,
        &__single {
          line-height: 32px;
          height: 32px;
          min-height: 32px;
        }
      }
    }
  }
}

@media screen and (max-width: 576px) {
  .date-reference-select-filter.date-reference-select-filter-selector {
    width: 100%;
  }
  .date-reference-select-filter .multiselect__content-wrapper {
    right: 0px;
    left: unset;
  }
}
</style>
<style lang="scss" scoped>
.icon {
  height: 24px;
  width: 24px;
}
.Fuell-Text--date-selector {
  font-size: 0.9em;
}
</style>
